import {
  FACTORY_ACCENT,
  FACTORY_DECK,
  FACTORY_HULL,
  SKIFF_BEAM_M,
  SKIFF_DRAFT_M,
  SKIFF_LENGTH_M,
  SKIFF_PLANING_KMH,
  SKIFF_REACH_M,
  normalizeBoat,
} from './limits.ts';
import { factoryFittings } from './fittings.ts';
import { sideViewColorsFromLivery } from './sideView.ts';
import type { BoatDocument } from './types.ts';
import { CURRENT_BOAT_VERSION } from './version.ts';

/** Filename stem of the factory hull, and the id stored on runs from before boat selection. */
export const SKIFF_BOAT_ID = 'skiff';

/** The one hull play still hard-codes, written out so the catalog is not empty. */
export function createSkiffBoat(): BoatDocument {
  return {
    version: CURRENT_BOAT_VERSION,
    name: 'Skiff',
    lengthM: SKIFF_LENGTH_M,
    beamM: SKIFF_BEAM_M,
    draftM: SKIFF_DRAFT_M,
    planingSpeedKmh: SKIFF_PLANING_KMH,
    turnM: SKIFF_REACH_M,
    accelM: SKIFF_REACH_M,
    brakeM: SKIFF_REACH_M,
    hull: { ...FACTORY_HULL },
    deck: { ...FACTORY_DECK },
    accent: { ...FACTORY_ACCENT },
    side: sideViewColorsFromLivery({
      hull: FACTORY_HULL,
      deck: FACTORY_DECK,
      accent: FACTORY_ACCENT,
    }),
    fittings: factoryFittings(),
  };
}

/** Unbound workshop boat. Same numbers as the skiff, with no title yet. */
export function createBoat(): BoatDocument {
  return { ...createSkiffBoat(), name: '' };
}

export function normalizeBoatDocument(boat: BoatDocument): BoatDocument {
  normalizeBoat(boat);
  return boat;
}
